import { randomId } from '~/helpers/randomId';
export default defineNuxtPlugin(function () {
  var _useNuxt2App = useNuxt2App(),
    $cookies = _useNuxt2App.$cookies;
  try {
    if (!$cookies.get('az_uuid')) {
      $cookies.set('az_uuid', randomId());
    }
  } catch (error) {
    console.error('Could not set unique id:', error);
  }
});